<template>
  <div>
    <!-- 登录后 -->
    <div class="header-user" v-if="isLoggedIn">
      <div class="message">
        <el-button @click="gotoPay()">快速充值</el-button>
        <!-- <el-button @click="gotoPay()">双11钜惠</el-button> -->
        <!-- <img
          class="btnimg"
          @click="gotoPay()"
          src="@/assets/images/activity/charge11.gif"
        /> -->
        <el-badge
          v-if="messageList.length > 0"
          :value="messageReads"
          :hidden="messageReads <= 0"
          class="item"
        >
          <el-dropdown placement="bottom" v-if="messageList.length > 0">
            <span class="el-dropdown-link">
              <a @click="showDetail(messageList[0].num)" class="btn-message">
                <i class="el-icon-chat-dot-round" style="font-size:20px;"></i>
              </a>
            </span>
            <!-- 下拉消息显示第一条 -->
            <el-dropdown-menu slot="dropdown" class="message-down-content">
              <div class="down-content">
                <p class="title">{{ messageList[0].title }}</p>
                <div class="text-box">
                  <a>
                    <span>{{ messageList[0].label }}</span>
                    <!-- <em>{{messageList[0].link}}</em> -->
                  </a>
                </div>
                <a class="btn-more" @click="showDetail(messageList[0].num)"
                  >查看更多</a
                >
              </div>
            </el-dropdown-menu>
            <!-- emd-下拉消息显示第一条 -->
          </el-dropdown>
          <a @click="table = true" class="btn-message" v-else>
            <i class="iconfont iconIMliaotian-shixin"></i>
          </a>
        </el-badge>
        <el-drawer
          title="消息通知"
          :visible.sync="table"
          direction="rtl"
          size="25%"
          class="drawer"
          :modal="false"
        >
          <drawer-content :messageList="messageList"></drawer-content>
        </el-drawer>
      </div>
      <div class="user">
        <span class="avatar-icon">
          <img :src="user.image" alt />
        </span>
        <div class="user-text">
          <el-dropdown @visible-change="onDropdownVisibleChange">
            <div class="el-dropdown-link">
              <div class="name">
                <span class="name">{{ user.name }}</span>
              </div>
              <a class="dot">
                <span>个人信息</span>
                <i class="el-icon-caret-bottom"></i>
              </a>
            </div>
            <el-dropdown-menu slot="dropdown">
              <div class="dropdown-user">
                <div class="balanced">
                  <p>账户余额</p>
                  <p class="second-line">
                    <span class="money">{{ balance }}</span
                    >元
                  </p>
                </div>
                <el-dropdown-item
                  v-for="(item, index) in headerUserMenus"
                  :key="index"
                >
                  <router-link
                    :to="item.link"
                    @click.native="loginOut(item.link)"
                    ><i :class="item.icon"></i> {{ item.name }}</router-link
                  >
                </el-dropdown-item>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <!-- end-登录后 -->
    <!-- 登录前/注册 -->
    <div class="header-info" v-else>
      <span class="avatar-icon">
        <img src="@/assets/images/user.svg" alt />
      </span>
      <span class="avatar-text">
        <router-link to="/login" @click.native="loginOut('login')"
          >登录</router-link
        >
        <i>|</i>
        <router-link class="reg" to="/registered">注册</router-link>
      </span>
    </div>
    <!-- end-登录/注册 -->
  </div>
</template>

<script>
import drawerContent from "./drawerContent.vue";
import {
  setToken,
  getTempUser,
  getToken,
  getMessageNum,
  setMessageNum,
} from "../../../utils/storage";
import { getSessionUser } from "@/api/auth";

export default {
  components: {
    drawerContent,
  },
  data() {
    return {
      table: false,
      dialog: false,
      loading: false,
      isLoggedIn: false,
      messageList: [],
      messageReads: 0,
      headerUserMenus: [],
      hideBadge: false, //是否隐藏消息数量
      user: {
        name: "",
        image: require("@/assets/images/user.svg"),
      },
      balance: 0,
    };
  },
  mounted() {
    this.isLoggedIn =
      getToken() != null && getToken() != "" && getTempUser() != "temp"
        ? true
        : false;

    console.log(
      "aaa:" + this.isLoggedIn + "bbb:" + getToken() + "ccc:" + getTempUser()
    );
    this.getUserList();
    this.getMessageList();
    // 监听“人工订单下载完成”事件 → 新增一条消息通知（静态文案）
    this.$EventBus.$on("workOrderComplete", this.onWorkOrderComplete);
  },
  beforeDestroy() {
    this.$EventBus.$off("workOrderComplete", this.onWorkOrderComplete);
  },
  methods: {
    async onDropdownVisibleChange(visible) {
      if (visible) {
        const { blance } = await getSessionUser({});
        this.balance = blance;
      }
    },
    getUserList() {
      if (this.isLoggedIn) {
        this.user.name =
          this.$store.state.common.userInfo.mail == ""
            ? this.$store.state.common.userInfo.mobile
            : this.$store.state.common.userInfo.mail;
      }
      this.headerUserMenus = this.constants.headerUserMenus;
    },
    //消息列表
    getMessageList() {
      if (
        JSON.stringify(this.$store.state.common.userInfo) !== "null" &&
        this.$store.state.common.userInfo.blance !== null &&
        this.$store.state.common.userInfo.blance > 0
      ) {
        this.messageList = [
          // {
          //   title: "【618活动火热进行】",
          //   label:
          //     "2024年618大促，充值预存最高赠送超100%，全年最佳囤图时机，抄底价，错过后悔一整年！点击查看>>",
          //   link: "/11huodong",
          //   time: "2024-06-01 00:00:00",
          //   num: 1,
          // },
          // {
          //   title: "【以图找图功能上线】",
          //   label:
          //     "以图找图功能已上线！欢迎体验，有任何问题可以联系客服反馈，感谢意见。系统非万能，不是所有图都能找到，结果来源于国外搜索引擎，如果搜无结果，也会扣费，如无法接受请勿使用。",
          //   link: "/find",
          //   time: "2023-02-28 00:00:00",
          //   num: 1,
          // },
          // {
          //   title: "【其他素材网促销通知】",
          //   label:
          //     "其他素材网促销中！adobe/123RF/Dreamstime促销2元一张（原价2.5）!istockphoto促销2.5元一张（原价3.5）随时可能结束，欢迎下载",
          //   link: "",
          //   time: "2022-12-14 00:00:00",
          //   num: 4,
          // },
          // {
          //   title: "【vectostock调价通知】",
          //   label:
          //     "vectostock由于上游供应成本上涨，目前价格已调整，恢复时间待定，您可以尽量选择其他低价素材网!",
          //   link: "",
          //   time: "2022-09-08 12:00:00",
          //   num: 3,
          // },
          // {
          //   title: "【一键搜索功能上线通知】",
          //   label:
          //     "全新功能已上线！一键搜索全球3亿素材，找素材，下载素材一站式搞定，赶紧来试试！内测中，仅对充值的会员开放，如有问题可以联系我们上方微信客服反馈意见哦，感谢",
          //   link: "/materialCenter",
          //   time: "2022-04-28 00:00:00",
          //   num: 2,
          // },
          // {
          //   title: "【原SS下载通道维护通知】",
          //   label:
          //     "SS/HAI由于原下载通道维护，恢复时间待定，现新增V2下载通道.为保证稳定下载，成本较贵，目前V2通道需要1.5元/张扣费，感谢谅解",
          //   link: "",
          //   time: "2022-02-21 22:00:00",
          //   num: 1,
          // },
        ];
      } else {
        this.messageList = [
          // {
          //   title: "【618活动火热进行】",
          //   label:
          //     "2024年618大促，充值预存最高赠送超100%，全年最佳囤图时机，抄底价，错过后悔一整年！点击查看>>",
          //   link: "/11huodong",
          //   time: "2024-06-01 00:00:00",
          //   num: 1,
          // },
          // {
          //   title: "【以图找图功能上线】",
          //   label:
          //     "以图找图功能已上线！欢迎体验，有任何问题可以联系客服反馈，感谢意见。系统非万能，不是所有图都能找到，结果来源于国外搜索引擎，如果搜无结果，也会扣费，如无法接受请勿使用。",
          //   link: "/find",
          //   time: "2023-02-28 00:00:00",
          //   num: 1,
          // },
          // {
          //   title: "【其他素材网促销通知】",
          //   label:
          //     "其他素材网促销中！adobe/123RF/Dreamstime促销2元一张（原价2.5）!istockphoto促销2.5元一张（原价3.5）随时可能结束，欢迎下载",
          //   link: "",
          //   time: "2022-12-14 00:00:00",
          //   num: 3,
          // },
          // {
          //   title: "【vectostock调价通知】",
          //   label:
          //     "vectostock由于上游供应成本上涨，目前价格已调整，恢复时间待定，您可以尽量选择其他低价素材网!",
          //   link: "",
          //   time: "2022-09-08 12:00:00",
          //   num: 2,
          // },
          // {
          //   title: "【原SS下载通道维护通知】",
          //   label:
          //     "SS/HAI由于原下载通道维护，恢复时间待定，现新增V2下载通道.为保证稳定下载，成本较贵，目前V2通道需要1.5元/张扣费，感谢谅解",
          //   link: "",
          //   time: "2022-02-21 22:00:00",
          //   num: 1,
          // },
        ];
      }
      this.messageReads =
        this.messageList.length - getMessageNum() > 0
          ? this.messageList.length - getMessageNum()
          : 0;
      if (this.messageReads > 0) {
        this.hideBadge = false;
      } else {
        this.hideBadge = true;
      }
    },
    loginOut(name) {
      console.log(name);
      //退出登陆
      if (name == "/login") {
        this.$store.commit("loginNameType", null);
        this.$store.dispatch("setUserInfo", null);
        this.$store.commit("updateShowAdvert", false);
        this.$store.commit("updateShowPost", false);
        this.$store.commit("token", null);
        setToken("");
      } else if (name == "/signOut") {
        this.$store.commit("loginNameType", null);
        this.$store.dispatch("setUserInfo", null);
        this.$store.commit("token", null);
        this.$store.commit("updateShowAdvert", false);
        this.$store.commit("updateShowPost", false);
        setToken("");
        this.$router.push({ path: "/login" });
      } else if (name == "/pay") {
        this.$store.commit("asideMenuId", "pay");
      } else if (name == "/personlCenter") {
        this.$store.commit("asideMenuId", "personlCenter");
      } else if (name == "/downloadHistory") {
        this.$store.commit("asideMenuId", "downloadHistory");
      }
    },
    gotoPay() {
      // let routeUrl = this.$router.resolve({ path: "/11huodong" });
      // window.open(routeUrl.href, "_blank");
      this.$router.push({ path: "/pay" });
      this.$store.commit("asideMenuId", "pay");
      console.log(this.$store.state.menu.asideMenuId);
    },
    showDetail(index) {
      this.table = true;
      setMessageNum(index);
      this.messageReads =
        this.messageList.length - getMessageNum() > 0
          ? this.messageList.length - getMessageNum()
          : 0;
      if (this.messageReads > 0) {
        this.hideBadge = false;
      } else {
        this.hideBadge = true;
      }
    },
    // 人工订单下载完成 → 往消息通知列表头部新增一条（静态文案），未读数+1，顶部显示提醒
    onWorkOrderComplete() {
      const now = new Date();
      const pad = (n) => (n < 10 ? "0" + n : "" + n);
      const time =
        now.getFullYear() +
        "-" +
        pad(now.getMonth() + 1) +
        "-" +
        pad(now.getDate()) +
        " " +
        pad(now.getHours()) +
        ":" +
        pad(now.getMinutes()) +
        ":" +
        pad(now.getSeconds());
      this.messageList.unshift({
        title: "【人工订单下载完成】",
        label: "你的人工订单下载订单完成了",
        link: "/workOrderDown",
        time: time,
        num: 999,
      });
      // 直接让未读数+1，确保顶部 badge 显示提醒
      this.messageReads = (this.messageReads || 0) + 1;
      this.hideBadge = false;
    },
  },
};
</script>

<style lang="scss">
.drawer {
  z-index: 10 !important;
  .el-drawer__header {
    margin-bottom: 20px;
    span {
      font-size: 18px;
      font-weight: 700;
      color: #333;
    }
  }
}
.header-user {
  .message {
    display: flex;
    align-items: center;
    justify-content: center;
    .btnimg {
      max-width: 100px;
      height: auto;
      width: 100%;
      text-align: center;
      cursor: pointer;
    }
    .el-badge__content.is-fixed {
      right: 15px;
      margin-top: 20px;
    }
    .el-button {
      color: #6b3d1e;
      font-weight: 700;
      background-image: linear-gradient(90deg, #ffe9d2, #ffbf8f);
      border-color: #fff;
      font-size: 14px;
      padding: 12px 15px;
      &:hover {
        background-image: linear-gradient(90deg, #f0bb93 100%, #f0bb93 100%);
        border-color: #fff;
      }
      &:active {
        background-image: linear-gradient(90deg, #ffe9d2, #ffbf8f);
        border-color: #fff;
      }
    }
  }
}
.message-down-content.el-dropdown-menu {
  padding: 0;
  .down-content {
    max-width: 250px;
    .title {
      padding: 10px 0;
      line-height: 22px;
      text-align: center;
      color: #EA4335;
      font-weight: 700;
      font-size: 14px;
    }
    .text-box {
      margin-bottom: 15px;
      padding: 0 10px;
      a {
        display: block;
        line-height: 20px;
        font-size: 12px;
        color: #666;
        cursor: pointer;
        span,
        em {
          font-size: 12px;
        }
        span {
          color: #666;
        }
        em {
          margin-left: 2px;
          color: #EA4335;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
    .btn-more {
      display: block;
      padding: 10px 0;
      width: 100%;
      text-align: center;
      background: #f8f8f8;
      color: #EA4335;
      font-size: 12px;
      cursor: pointer;
    }
  }
}
.dropdown-user {
  width: 130px;
  .el-dropdown-menu__item:not(.is-disabled):hover,
  .el-dropdown-menu__item:focus {
    background: #f3f4f9;
  }
  .el-dropdown-menu__item {
    padding: 0px;
  }
  a {
    color: #666;
    display: inline-block;
    padding-left: 20px;
    width: 110px;
    &:hover {
      color: #000;
    }
  }

  .balanced {
    font-size: 14px;
    padding: 20px;

    .second-line {
      margin-top: 5px;
    }

    .money {
      font-size: 20px;
    }
  }
}
.user-text {
  .el-dropdown {
    height: 70px;
  }
}
</style>
<style lang="scss" scoped>
.header-user {
  display: flex;
  align-items: center;
  justify-content: center;
  .message {
    position: relative;
    text-align: center;
    .btn-message {
      display: block;
      padding: 0 20px;
      height: 70px;
      line-height: 70px;
      cursor: pointer;
      color: #1b2337;
      &:hover {
        color: #EA4335;
      }
    }
  }
}
.avatar-icon {
  margin-right: 20px;
  display: inline-block;
  width: 46px;
  height: 46px;
  cursor: pointer;
}
.header-info {
  display: flex;
  font-size: 14px;
  color: #cdcdcd;
  white-space: nowrap;
  align-items: center;
  cursor: default;
  .avatar-text {
    display: flex;
    a {
      width: 40px;
      font-size: 14px;
      color: #333;
      text-align: center;
    }
  }
}
.user {
  margin-left: 40px;
  display: flex;
  align-items: center;
  cursor: pointer;
  .user-text {
    float: left;
    .name {
      width: 130px;
      margin-top: 12px;
      text-align: left;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      line-height: 16px;
      span {
        font-size: 12px;
        font-weight: 700;
        color: #333;
      }
    }
    .dot {
      width: auto;
      text-align: left;
      margin-top: 3px;
      padding: 0 10px;
      padding-right: 5px;
      height: 20px;
      line-height: 20px;
      border-radius: 16px;
      background-color: rgba(7, 115, 252, 0.1);
      border: 1px solid rgba(7, 115, 252, 0.1);
      position: relative;
      display: inline-block;
      span {
        font-size: 12px;
        color: #EA4335;
        display: inline-block;
        text-align: center;
        margin-right: 5px;
      }
      i {
        font-size: 12px;
        color: rgb(7, 115, 252);
      }
    }
  }
}
</style>
